export const SET_ACTIVE_CITIES = 'PRO/SET_ACTIVE_CITIES'
export type SET_ACTIVE_CITIES = typeof SET_ACTIVE_CITIES
